import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../constants/Languages.js';
import {Link} from 'react-router-dom';

//import img
import causesImg from '../assets/icons/arrow-circle-full-yellow.svg';
import sorryImg from '../assets/icons/arrow-circle-full-green.svg';

const Error404Page = ({ clang }) => {
    return (
      <div className="error-page">
          <h2 className="error-page--title">
              {lang[clang].errors.error_404}
              <p className="error-page--code">{lang[clang].errors.error_code} 404</p>
          </h2>
          <div className="error-page--separator"></div>
          <span className="error-page--causes">
              <img className="error-page--causes-img" src={causesImg} alt="" />
              {lang[clang].errors.error_causes}
          </span>
          <ul dangerouslySetInnerHTML={{__html: lang[clang].errors.error_404_desc}} className="results__no-results--desc"></ul>
          <h3 className="error-page--sorry">
              <img className="error-page--sorry-img" src={sorryImg} alt="" />
              {lang[clang].errors.sorry}
          </h3>
          <div className="error-page--what-now-container">
              <p className="error-page--what-now">{lang[clang].errors.what_now}</p>
              <Link to={`/`} className="error-page--link" title={lang[clang].errors.go_to_homepage}>{lang[clang].errors.go_to_homepage}</Link>
              <span className="error-page--what-now-separator">|</span>
              <span className="error-page--use-map">{lang[clang].errors.use_map}</span>
          </div>
      </div>
    );
};

Error404Page.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(Error404Page);



// WEBPACK FOOTER //
// ./src/components/Error404Page.js